const AUTO_PAPER_SHOP_IDS: Array<string> = [
  'gb0e93802701846758',
  'bed7j46g0145908312'
]

export function canUseAutoPaper(shopId: string): boolean {
  return AUTO_PAPER_SHOP_IDS.indexOf(shopId) !== -1
}

export function isAutoPaperUrl(url: string): boolean {
  return /^\/auto-paper(?:\/|[?#]|$)/.test(url) || /(?:[?&])source=autoPaper(?:[&#]|$)/.test(url)
}
